module.exports = __webpack_public_path__ + "img/notifications/notification-prompt@2x-760255333e8c34bfb9ed90f08b16f9e1.png";